import React from 'react';

const InactiveProposalBanner = ({ activeVersionUrl }) => {
  return (
    <div
      className="relative rounded-2xl px-6 py-5 mb-6 flex items-start gap-4"
      style={{
        background: 'rgba(217,119,6,0.12)',
        border: '1px solid rgba(217,119,6,0.4)',
      }}
    >
      {/* Warning icon */}
      <svg
        className="w-6 h-6 flex-shrink-0 mt-0.5"
        style={{ color: 'rgba(245,158,11,1)' }}
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
        />
      </svg>

      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold" style={{ color: 'rgba(245,158,11,1)' }}>
          You are viewing an outdated version of this proposal.
        </p>
        {activeVersionUrl ? (
          <a
            href={activeVersionUrl}
            className="inline-block mt-1.5 text-sm font-medium underline underline-offset-2 hover:opacity-80 transition-opacity"
            style={{ color: 'rgba(251,191,36,1)' }}
          >
            View the latest version
          </a>
        ) : (
          <p className="mt-1.5 text-sm" style={{ color: 'rgba(217,119,6,0.8)' }}>
            A newer version is being prepared. Please contact your relationship manager for the latest version.
          </p>
        )}
      </div>
    </div>
  );
};

export default InactiveProposalBanner;
